import { EActionTypes } from '../../constants/actionTypes/specialists';
import { TReduxActions } from '../../types/redux';
import {
  IGetSpecialistsCatalogResponse,
  IGetSpecialistsCatalogResponseError,
} from '../../repositories/demand/v1/get-specialists-catalog';

export interface ISpecialistsStoreData {
  data: IGetSpecialistsCatalogResponse | null;
  isFetching: boolean;
  errors: IGetSpecialistsCatalogResponseError;
}

const initialState: ISpecialistsStoreData = {
  data: null,
  isFetching: false,
  errors: {
    errors: [],
    message: '',
  },
};

export function specialistsReducer(state = initialState, action: TReduxActions) {
  switch (action.type) {
    case EActionTypes.GET_SPECIALISTS_REQUEST:
      return { ...state, isFetching: true };

    case EActionTypes.GET_SPECIALISTS_SUCCESS:
      return { ...state, data: action.payload, isFetching: false };

    case EActionTypes.GET_SPECIALISTS_FAILURE:
      return { ...state, errors: action.payload, isFetching: false };

    default:
      return state;
  }
}
